// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"styles_placeholder__3kMm7","pulse":"styles_pulse__1REEQ"};